module.exports = __webpack_public_path__ + "static/media/photo50.e0df0360.jpg";